import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux'
import Header from 'components/Header/Header';
import { routes } from 'utils/routers.constants';

export default function RouteWrapper({
  component: Component,
  isPrivate,
  outside,
  ...rest
}) {
  const { loggedIn } = useSelector(state => state.Auth);


  if (!loggedIn && isPrivate) {
    return <Redirect to={routes.SIGN_IN} />;
  }

  if (loggedIn && !isPrivate && !outside) {
    return <Redirect to={routes.HOME} />;
  }

  return (
    <>
      {isPrivate ? (
        <Header currentRoute={rest.path}>
          <Route
            {...rest}
            render={props => (
              <Component {...props} />
            )}
          />
        </Header>
      ) : (
          <Route
            {...rest}
            render={props => (
              <Component {...props} />
            )}
          />
        )}
    </>
  );
}

RouteWrapper.defaultProps = { isPrivate: false };
